import { get, post } from '../../../services/request';

export const getLiveAvailableShiftsWithPagination = async (payload) => {
    try {
        const response = await post('CapacityVsDemand/GetCapacityVSDemandAvailableShiftsRPCEWithPagination', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

export const fetchLegendTableData = () => {
    return get('CapacityVsDemand/GetCapsVsDemandLatestSimulatorLegend', {
    })
};